import { useCallback, type RefObject } from "react"

export function useScrollToSection() {
  const scrollTo = useCallback(
    (ref: RefObject<HTMLElement | null>, delay = 300) => {
      setTimeout(() => {
        ref.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      }, delay)
    },
    []
  )

  return { scrollTo }
}
